/* eslint-disable linebreak-style */
import React, { useEffect, Suspense, useMemo } from 'react';
import { Switch, Route } from 'react-router-dom';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

import ClevertapReact from 'aurora-utils/CleverTap';
import { ACTIVE_KEY } from 'aurora-utils/constants';
import history from '../../utils/history';
import NotFound from '../Pages/Standalone/NotFound';
import Application from './Application';
import AuroraCoreLayoutWrapper from './AuroraCoreLayoutWrapper';
import withAuthorizationRouter from '../Session/withAuthorizationRouter';
import {
  Login,
  Login2,
  Signup,
  Signin,
  OTP,
  AdminPayment,
  LandingPage,
  VerifyEmail,
  ForgotPassoword,
} from '../auroraPageLoader';
import { firebaseConfig } from '../../utils/constants';
import { Loading } from '../../components';
import PaymentEmail from '../Routes/EmailTemplates/PaymentEmail';
import PaymentInvoice from '../Routes/EmailTemplates/PaymentInvoice';
const { BASE_KEY } = ACTIVE_KEY;

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// ClevertapReact.initialize(BASE_KEY);
// export { analytics };
function App() {
  useEffect(() => {
    if (!history?.location?.pathname.includes('/login') && localStorage.getItem('uae_pass_errorCode_count') === '2') {
      localStorage.removeItem('uae_pass_errorCode_count');
      localStorage.removeItem('uae_pass_errorCode');
    }
  }, [history?.location?.pathname]);

  const isProduction = useMemo(() => {
    return process.env.REACT_APP_ACTIVE_WEB_URL === 'https://accessrp.adgm.com';
  }, []);

  return (
    <Suspense fallback={<Loading />}>
      <AuroraCoreLayoutWrapper>
        <Switch>
          <Route exact path='/' component={LandingPage} />
          {!isProduction && <Route exact path='/manual/login' component={Signin} />}
          <Route exact path='/auth/signup' component={Signup} />
          <Route exact path='/auth/login-eid' component={Login} />
          <Route exact path='/auth/login-nonUae' component={Login} />
          <Route exact path='/auth/reset-password' component={Login} />
          <Route exact path='/auth/login-uaePass' component={Login} />
          <Route exact path='/auth/login-unified' component={Login} />
          <Route exact path='/auth/signup-eid' component={Signup} />
          <Route exact path='/auth/signup-unified' component={Signup} />
          <Route exact path='/auth/otp' component={OTP} />
          <Route exact path='/auth/verify-email' component={VerifyEmail} />
          <Route exact path='/auth/forgot-password' component={ForgotPassoword} />
          <Route exact path='/login' component={Login2} />
          <Route exact path='/admin-payment' component={AdminPayment} />
          {/* temporary paths for email & invoice templates starts here */}
          <Route exact path='/email' component={PaymentEmail} />
          <Route exact path='/invoice' component={PaymentInvoice} />
          {/* temporary paths for email & invoice templates ends here */}
          <Route path='/app' component={withAuthorizationRouter(Application)} />
          <Route component={NotFound} />
        </Switch>
      </AuroraCoreLayoutWrapper>
    </Suspense>
  );
}

export default App;
